function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "checkbox-checked");

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "gray",
  d: "M15,17.9H0v-15H15ZM1.5,16.41h12v-12H1.5Z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#99c24d",
  d: "M2,9.31s1.74,0,3.65,6L8,13.63a42.32,42.32,0,0,1,10.1-13L17.7,0s-5,2.25-11,11.23c0,0-1.21-3.14-2.37-3.56C4.31,7.67,3.42,7.64,2,9.31Z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 18.08,
    height: 17.9,
    viewBox: "0 0 18.08 17.9"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/checkbox-checked.79c112a2.svg";
export { SvgComponent as ReactComponent };